export default "<p>\r\n  loan-status works!\r\n</p>\r\n";